import { render } from "./LanguageMenu.vue?vue&type=template&id=6009f39e&scoped=true"
import script from "./LanguageMenu.vue?vue&type=script&lang=js"
export * from "./LanguageMenu.vue?vue&type=script&lang=js"

import "./LanguageMenu.vue?vue&type=style&index=0&id=6009f39e&lang=css"
import "./LanguageMenu.vue?vue&type=style&index=1&id=6009f39e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6009f39e"]])

export default __exports__